import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../hooks/use-page-title.hook';

interface PageTitleProps {
  title?: string;
  prefix?: string;
  suffix?: string;
}

const PageTitle: React.FC<PageTitleProps> = ({ title, prefix = 'Pro Bot', suffix }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const { setTitle } = usePageTitle({ prefix, suffix });

  useEffect(() => {
    if (title) {
      setTitle(title);
      return;
    }

    // Auto-generate title based on route
    const pathSegments = location.pathname.split('/').filter(Boolean);

    if (pathSegments.length === 0) {
      setTitle('dashboard.title');
      return;
    }

    // Map common routes to translation keys
    const routeTitleMap: Record<string, string> = {
      dashboard: 'dashboard.title',
      user: 'users.title',
      tenant: 'tenants.title',
      role: 'roles.title',
      workflow: 'workflows.title',
      analytic: 'analytics.title',
      trail: 'trails.title',
      country: 'countries.title',
      sysadmin: 'common.systemAdmin',
    };

    const lastSegment = pathSegments[pathSegments.length - 1];
    const titleKey = routeTitleMap[lastSegment] || `${lastSegment}.title`;

    setTitle(titleKey);
  }, [location.pathname, title, setTitle]);

  return null; // This component doesn't render anything
};

export default PageTitle;
